import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { insertIf } from '@backmarket/utils/collection/insertIf'

import { ROUTES as AUTH_ROUTES } from '../auth/route-names'

import { ROUTE_NAMES } from './constants'
import servicesHubRoutes from './services-hub/routes'

export const { DASHBOARD } = ROUTE_NAMES

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const hasServicesHubEnabled =
    experiments['experiment.servicesHub'] === 'withServicesHub'

  return [
    {
      path: 'dashboard',
      name: DASHBOARD.SELF,
      redirect: { name: DASHBOARD.MY_ORDERS.SELF },
      component: () => import('./layout/DashboardLayout.vue'),
      children: [
        {
          path: 'profile',
          name: DASHBOARD.KYC.PROFILE,
          component: () => import('./profile/Profile.vue'),
          meta: {
            owners: ['bot-squad-sales-customer-care-front'],
          },
        },
        {
          path: 'favorites',
          name: DASHBOARD.FAVORITES,
          component: () => import('./favorites/Favorites.vue'),
          meta: {
            owners: ['bot-squad-lifecycle-front'],
          },
        },
        {
          path: 'others',
          component: () => import('./my-other-things/MyOtherThings.vue'),
          name: DASHBOARD.KYC.OTHER,
          meta: {
            owners: ['bot-squad-lifecycle-front'],
          },
        },
        {
          path: 'orders',
          name: DASHBOARD.MY_ORDERS.SELF,
          component: () => import('./my-orders/MyOrders.vue'),
          meta: {
            owners: ['bot-squad-sales-customer-care-front'],
          },
        },
        {
          path: 'sales',
          name: DASHBOARD.MY_SALES,
          component: () => import('./my-sales/MySales.vue'),
          meta: {
            owners: ['bot-squad-circularity-order-lifecycle-front'],
          },
        },
        {
          path: 'orders/:orderId/orderlines/:orderlineId/insurances/withdraw',
          component: () =>
            import('./insurances-withdraw/InsurancesWithdraw.vue'),
          name: DASHBOARD.MY_ORDERS.WITHDRAW.INSURANCES,
          meta: {
            disableClientSideNavigation: () => true,
            owners: ['bot-squad-b2cservices-front'],
          },
        },
        {
          path: 'refer-friend',
          component: () => import('./refer-a-friend/ReferAFriend.vue'),
          name: DASHBOARD.KYC.REFER_FRIEND,
          meta: {
            owners: ['bot-squad-lifecycle-front'],
          },
        },
        ...insertIf(hasServicesHubEnabled, [
          {
            path: 'services-hub',
            name: DASHBOARD.SERVICES_HUB,
            component: () => import('./services-hub/ServicesHub.vue'),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
            },
          },
        ] as RouteRecordRaw[]),
      ],
      meta: {
        auth: {
          required: true,
          // TODO: [FRONT-1199] remove this after global config change
          redirection: { name: AUTH_ROUTES.AUTH.LOGIN },
        },
        owners: ['bot-squad-sales-customer-care-front'],
      },
    },
    {
      component: () => import('./profile/DeleteAccount/DeleteAccount.vue'),
      name: DASHBOARD.KYC.DELETE_ACCOUNT,
      path: 'dashboard/profile/delete-account',
      meta: {
        owners: ['bot-squad-identity'],
        auth: {
          required: true,
          redirection: { name: AUTH_ROUTES.AUTH.LOGIN },
        },
      },
    },
    ...insertIf(hasServicesHubEnabled, servicesHubRoutes),
  ]
}
